import { defineMessages } from 'react-intl.macro';

import React, { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';

import { useSelector } from '@tmapy/redux';
import { PageTitle, SecondaryLink, SIZE, UserInfo } from '@tmapy/style-guide';

import './Header.scss';

import { Search } from './Search';

const msg = defineMessages({
  login: {
    id: 'login',
    defaultMessage: 'Přihlásit se',
  },
  logout: {
    id: 'logout',
    defaultMessage: 'Odhlásit se',
  },
});

export const Header: React.FC<{}> = () => {
  const appData = useSelector((state) => state.edas.appData.data);
  const { config, user } = appData;
  const { city, name, auth, menu } = config;
  const { login, logout } = auth;

  const handleLogin = useCallback(() => {
    window.location.href = login;
  }, [login]);

  const handleLogout = useCallback(() => {
    window.location.href = logout;
  }, [logout]);

  return (
    <header className='e-header sg-a-py-2'>
      <div className='e-u-block'>
        <div className='sg-a-d-f sg-a-ai-b sg-a-cg-2'>
          <div className='sg-a-f-a sg-a-d-f sg-a-fw-w sg-a-jc-sb sg-a-ai-b sg-a-cg-4 sg-a-rg-1'>
            <PageTitle linkElement={<Link to='/' />} company={city}>
              {name}
            </PageTitle>
            {menu.length > 0 && (
              <div className='sg-a-d-f sg-a-ai-b sg-a-cg-1'>
                {menu.map((item, index) => (
                  <SecondaryLink
                    key={index}
                    isInverse
                    size={SIZE.SML}
                    href={item.url}
                    target='_blank'
                  >
                    {item.label}
                  </SecondaryLink>
                ))}
              </div>
            )}
          </div>
          <UserInfo
            isLoggedIn={!!user}
            avatar={user?.[0]}
            name={user}
            loginLabel={<FormattedMessage {...msg.login} />}
            logoutLabel={<FormattedMessage {...msg.logout} />}
            onLogin={handleLogin}
            onLogout={handleLogout}
          />
        </div>
        <div className='sg-a-mt-2 e-header--searchBar'>
          <Search />
        </div>
      </div>
    </header>
  );
};
